export default "__VITE_ASSET__b0186b62__"